var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9148 8.3628H13.3716V10.5828C14.0136 9.306 15.66 8.1588 18.1332 8.1588C22.8744 8.1588 24 10.7004 24 15.3636V24H19.2V16.4256C19.2 13.77 18.558 12.2724 16.9236 12.2724C14.6568 12.2724 13.7148 13.8864 13.7148 16.4244V24H8.9148V8.3628ZM0.684 23.796H5.484V8.1588H0.684V23.796ZM6.1716 3.06C6.17178 3.46233 6.09199 3.86068 5.93686 4.2319C5.78174 4.60313 5.55438 4.93982 5.268 5.2224C4.68768 5.79915 3.90217 6.12198 3.084 6.12C2.26727 6.11945 1.48357 5.79744 0.9024 5.2236C0.617054 4.94006 0.390463 4.60299 0.235612 4.23172C0.0807618 3.86045 0.000694958 3.46227 0 3.06C0 2.2476 0.324 1.47 0.9036 0.8964C1.48426 0.32179 2.26829 -0.000359053 3.0852 3.00317e-07C3.9036 3.00317e-07 4.6884 0.3228 5.268 0.8964C5.8464 1.47 6.1716 2.2476 6.1716 3.06Z",
    fill: "#0072B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInWhiteIcon);
export default __webpack_public_path__ + "static/media/LinkedInWhiteIcon.ef2c4d318ec977144233bf6ef7719184.svg";
export { ForwardRef as ReactComponent };